export default __webpack_public_path__ + "static/media/pantry2-before2-2048w.7471164a.png";